export const PRODUCTION = process.env.NODE_ENV === 'development'
// export const PRODUCTION = process.env.NODE_ENV === 'production'

export const API_URL = 'https://betaapi.complytrackers.com';

//  export const API_URL = 'https://api.complytrackers.com';

// export const API_URL = 'http://localhost:3000';
